<div class="detail" *ngIf="payload; let data">
  
  <div class="row">
    <div class="col" *ngIf="data.transportJourneys.roadTransport.truckNumber">
      <label class="label">{{'common.vehicle_#_txt' | translate}}</label>
      <p class="text-bold">{{ data.transportJourneys.roadTransport.truckNumber }}</p>
    </div>
    <div class="col" *ngIf="data.transportJourneys.roadTransport.driverPhone">
      <label class="label">{{'common.driver_phone_txt' | translate}}</label>
      <p class="text-bold">{{ data.transportJourneys.roadTransport.driverPhone }}</p>
    </div>
    <div class="col" *ngIf="data.status">
      <label class="label">{{'common.status_txt' | translate}}</label>
      <p class="text-bold">{{ data.status }}</p>
    </div>
  </div>

  <div class="row">
    <div class="col" *ngIf="data.referenceNumber">
      <label class="label">{{'common.shipment_reference_txt' | translate}}</label>
      <p class="text-bold">{{data.referenceNumber || '' }}</p>
    </div>
    <div class="col" *ngIf="data.transportJourneys.roadTransport.carrier">
      <label class="label">{{'common.carrier_txt' | translate}}</label>
      <p class="text-bold">{{ data.transportJourneys.roadTransport.carrier }}</p>
    </div>
    <div class="col" *ngIf="data.emissions?.co2e?.value let v">
      <label class="label">{{'common.co2_emissions_txt' | translate}}</label>
      <p>
        <span class="value">{{ v | number : '1.0-2' }} {{data.emissions.co2e.unit || '' }}</span>
        <span>
          <dp-svg [src]="udsIconMap.infoExclamation" w="16" placement="bottom"
            tooltip="Total Port to Port GHG emission basis GLEC framework Default factors"></dp-svg>
        </span>
      </p>
    </div>
  </div>

</div>